module.exports = __webpack_public_path__ + "assets/src/style/img/footer-hanze.png?69e044d543ad7b77f6f995f20a86a25d";